import { render, staticRenderFns } from "./IconHomePresent.vue?vue&type=template&id=4208d473"
import script from "./IconHomePresent.vue?vue&type=script&lang=ts"
export * from "./IconHomePresent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports